import { ArrowLeft, CheckCircle } from "lucide-react";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function CustomerRegistrationSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = location.state?.userData || {};
  const referCode = location.state?.referCode || "";

  useEffect(() => {
    // Set body styles for full-screen display
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflowX = "hidden";
    document.body.style.backgroundColor = "#e5e7eb";

    return () => {
      // Clean up body styles
      document.body.style.margin = "";
      document.body.style.padding = "";
      document.body.style.overflowX = "";
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleBack = () => {
    navigate("/");
  };

  return (
    <>
      <div
        className="hidden lg:block h-[calc(100vh-120px)] bg-primary-color flex-col overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/images/successRegister.jpg')",
        }}
      >
        <div className="">
          <div className="flex-1 flex items-center justify-center py-4">
            <div className="bg-white/35 backdrop-blur-xl border border-white/30 py-20 px-16 rounded-2xl flex w-[1119px] h-[477px] gap-3">
              <div className="flex flex-col justify-between w-[508px] h-[309px]">
                <div className="relative border-black">
                  <h1 className="text-[100px] tracking-[0.06em] text-white absolute top-[-20px] right-[130.5px]">
                    Thank
                  </h1>
                  <h1 className="text-[100px] tracking-[.06em] text-white absolute top-[5.5rem] right-[15.3rem]">
                    You
                  </h1>
                </div>
                <button onClick={handleBack} className="cursor-pointer">
                  <div className="flex gap-1 ps-10">
                    <ArrowLeft />
                    <span>Back</span>
                  </div>
                </button>
              </div>
              <div className="flex w-[508px] h-[309px] bg-white gap-3 flex-col p-8 lg:p-12 items-center justify-center rounded-3xl">
                <div className="">
                  <div className="font-semibold text-[45px] flex items-baseline gap-1">
                    <CheckCircle className="text-green-500" />
                    <span className="tracking-[.02em]">Successful</span>
                  </div>

                  {/* Display registration info */}
                  <div className="text-center mt-2">
                    {userData.username && (
                      <p className="text-sm text-gray-600">
                        Welcome,{" "}
                        <span className="font-semibold">
                          {userData.username}
                        </span>
                        !
                      </p>
                    )}
                    {referCode && (
                      <p className="text-xs text-gray-500 mt-1">
                        Referral Code:{" "}
                        <span className="font-semibold">{referCode}</span>
                      </p>
                    )}
                  </div>

                  <div className="flex w-full gap-0 items-center text-center">
                    <hr className="border border-black w-1/3 my-6" />
                    <span className="text-[12px] w-full">You can Choose</span>
                    <hr className="border border-black w-1/3 my-6" />
                  </div>
                  <div className="flex gap-3 justify-between">
                    <a
                      href="https://play.google.com/store"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center border rounded-md px-2 py-1 border-gray-500 shadow-xl"
                    >
                      <img
                        src="/images/playstore.png"
                        alt="Google Play"
                        className="w-6 h-6 mr-2"
                      />
                      <div className="flex flex-col text-left leading-tight">
                        <span className="text-[6px]">GET IT ON</span>
                        <span className="text-[12px] font-semibold">
                          Google Play
                        </span>
                      </div>
                    </a>

                    <a
                      href="https://www.apple.com/app-store/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center border border-gray-500 shadow-xl rounded-md px-2 py-1"
                    >
                      <img
                        src="/images/apple-logo.png"
                        alt="App Store"
                        className="w-6 h-6 mr-2"
                      />
                      <div className="flex flex-col text-left leading-tight">
                        <span className="text-[6px]">Download on the</span>
                        <span className="text-[12px] font-semibold">
                          App Store
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="block lg:hidden">
        <div className="bg-gray-200 border">
          <div className="flex flex-1 my-40 mx-5 border border-gray-400 shadow-xl bg-white rounded-3xl p-20 justify-center items-center">
            <div className="w-[216px] h-[106px] px-3 relative">
              <div className="font-semibold text-[35px] flex items-baseline gap-1">
                <CheckCircle className="text-green-500" />
                <span className="tracking-[.02em]">Successful</span>
              </div>

              {/* Display registration info for mobile */}
              <div className="text-center mt-1">
                {userData.username && (
                  <p className="text-xs text-gray-600">
                    Welcome, {userData.username}!
                  </p>
                )}
              </div>

              <div className="flex w-full gap-0 items-center text-center justify-center absolute top-[32px] right-0">
                <hr className="border border-black w-1/5 my-6" />
                <span className="text-[9px] w-2/5">You can Choose</span>
                <hr className="border border-black w-1/5 my-6" />
              </div>
              <div className="flex justify-center gap-2 w-[211px] h-[31px] absolute bottom-0 right-[.1rem]">
                <a
                  href="https://play.google.com/store"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center border rounded-md px-2 py-1 border-gray-500 shadow-xl w-[98px] h-[31px]"
                >
                  <img
                    src="/images/playstore.png"
                    alt="Google Play"
                    className="w-4 h-4 mr-2"
                  />
                  <div className="flex flex-col text-left leading-tight">
                    <span className="text-[6px]">GET IT ON</span>
                    <span className="text-[9px] font-semibold">
                      Google Play
                    </span>
                  </div>
                </a>

                <a
                  href="https://www.apple.com/app-store/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center border border-gray-500 shadow-xl rounded-md px-2 py-1"
                >
                  <img
                    src="/images/apple-logo.png"
                    alt="App Store"
                    className="w-4 h-4 mr-2"
                  />
                  <div className="flex flex-col text-left leading-tight">
                    <span className="text-[6px]">Download on the</span>
                    <span className="text-[9px] font-semibold">App Store</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
